import { PencilIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import moment from 'moment'

export default function LeadsTableRow({ lead, isSelected, onSelectLead }) {
  // console.log('Rendering lead row for:', lead);

  const formatDate = (dateString) => {
    return moment(dateString).format('YYYY-MM-DD');
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      'new': 'bg-blue-500 text-white',
      'won': 'bg-green-500 text-white',
      'lost': 'bg-red-500 text-white'
    };

    const className = statusClasses[status?.toLowerCase()] || 'bg-gray-100 text-gray-800';

    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>
        {status || 'Unknown'}
      </span>
    );
  };

  return (
    <tr className="hover:bg-gray-100">
      <td className="py-2 px-4 border-b border-gray-300 text-left w-12">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelectLead(lead._id, e.target.checked)}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
        />
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <Link 
            to={`/leads/details/${lead._id}`}
            className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
          >
            {lead.customerName || 'N/A'}
          </Link>
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0h3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          {lead.source || 'N/A'}
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7h16M4 12h10m-7 5h7" />
          </svg>
          {lead.campaign || '-'}
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          {lead.customerTel || 'N/A'}
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        {getStatusBadge(lead.status)}
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-black">
          {lead.created ? formatDate(lead.created) : 'N/A'}
        </span>
      </td>
    <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
      <Link
        to={`/leads/edit/${lead._id}`}
        className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-200"
      >
        <PencilIcon className="h-4 w-4" />
        <span>Edit</span>
      </Link>
    </td>
    </tr>
  );
}
